import React from "react";
import { useState, createContext, useEffect } from "react";


export const MedicalContext = createContext();

const MedicalContextProvider = (props) => {

  const [PerRecordsCodes] = useState(() => {
    const localData = localStorage.getItem("PerRecordsCodes");
    return localData ? JSON.parse(localData) : 
    {
      "Sobrepeso": 'AP009',
      "Obesidad": 'AP006',
      "Hipertensión": 'AP003',
      "Resistencia a la insulina": 'AP011',
      "Diabetes": 'AP002',
      "Rinitis alérgica": 'AP005',
      "Asma": 'AP004',
      "Hipotiroidismo": 'AP001',
      "Tabaquismo": 'AP010', 
      "EPOC": 'AP013',
      "Colesterol Alto": 'AP012',
      "Hipoacusia": 'AP014',
      "Osteoporosis": 'AP015',
      "Enfermedad renal crónica": 'AP016',
      "Glaucoma": 'AP017',
      "Síndrome ovario poliquístico": 'AP018',
      "Anemia": 'AP019',
      "Menopausia": 'AP020',
      "Enfermedad Cardiovascular": 'AP035',
      "Infarto Agudo al Miocardio": 'AP036',
      "Angina Estable/Inestable" : 'AP037',
      "Antecedente de Angioplastia" : 'AP038',
      "Bypass Aortocoronario" : 'AP039',
      "Ataque Cerebrovascular Isquémico" : 'AP040',
      "Ataque Cerebral Isquémico Transitorio" : 'AP041',
      "Enfermedad Aórtica Ateroesclerótica" : 'AP042',
      "Enfermedad Renovascular" : 'AP043',
      "Enfermedad Carotídea" : 'AP044',
      "Enfermedad Arterial Periférica" : 'AP045'
    };
  });

  const [FamRecordsCodes] = useState(() => {
    const localData = localStorage.getItem("FamRecordsCodes");
    return localData ? JSON.parse(localData) : 
    {
      "Resistencia a la insulina": 'AF008',
      "Diabetes": 'AF007',
      "Hipertensión": 'AF021',
      "Rinitis alérgica": 'AF022',
      "Hipotiroidismo": 'AF023',
      "Dislipidemia": 'AF024',
      "Enfermedades Cardiovasculares (Infarto, ACV, etc)": 'AF025',
      "Demencia - enfermedad de alzheimer": 'AF026',
      "Glaucoma": 'AF027',
      "Hipoacusia": 'AF028',
      "Cáncer Colorrectal": 'AF029',
      "Cáncer de Estómago": 'AF030',
      "Cáncer de Pulmón": 'AF031',
      "Cáncer de vesícula": 'AF032',
      "Cáncer de próstata": 'AF033',
      "Cáncer de mama": 'AF034'
    };
  });

  const [RelatedExams, SetRelatedExams] = useState(() => {
    const localData = localStorage.getItem("RelatedExams");
    return localData ? JSON.parse(localData) : [];
  });

  useEffect(() => {
    localStorage.setItem(
      "RelatedExams",
      JSON.stringify(RelatedExams)
    );
  }, [RelatedExams]);

  const [PreviewRelatedExams, SetPreviewRelatedExams] = useState(() => {
    const localData = localStorage.getItem("PreviewRelatedExams");
    return localData ? JSON.parse(localData) : [];
  });

  useEffect(() => {
    localStorage.setItem(
      "PreviewRelatedExams",
      JSON.stringify(PreviewRelatedExams)
    );
  }, [PreviewRelatedExams]);

  const [OpenAccess, setOpenAccess] = useState(() => {
    const localData = localStorage.getItem("OpenAccess");
    return localData ? JSON.parse(localData) :
    false
  });

  useEffect(() => {
    localStorage.setItem("OpenAccess", JSON.stringify(OpenAccess));
  }, [OpenAccess]);

  const [HabitsCalculated, setHabitsCalculated] = useState(() => {
    const localData = localStorage.getItem("HabitsCalculated");
    return localData ? JSON.parse(localData) :
    false
  });

  useEffect(() => {
    localStorage.setItem("HabitsCalculated", JSON.stringify(HabitsCalculated));
  }, [HabitsCalculated]);



  return (
    <MedicalContext.Provider
      value={{
        PerRecordsCodes,
        FamRecordsCodes,
        RelatedExams, SetRelatedExams, PreviewRelatedExams, SetPreviewRelatedExams, 
        HabitsCalculated, setHabitsCalculated, OpenAccess, setOpenAccess
      }}>
      {props.children}
    </MedicalContext.Provider>
  );
};
export default MedicalContextProvider;
